import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Contact = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  
  // Contact form data
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  // Company contact info (could be fetched from API)
  const [contactInfo, setContactInfo] = useState({
    phone1: '+1 (555) 123-4567',
    phone2: '+1 (555) 987-6543',
    email: 'info@octafxx.in',
    address: '123 Business Street, Suite 100, New York, NY 10001',
    workingHours: 'Mon - Fri: 9:00 AM - 6:00 PM'
  });

  // Check if user is logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('LoggedIn');
    
    // Load user data if logged in
    if (isLoggedIn === '1') {
      const userName = localStorage.getItem('name');
      const userEmail = localStorage.getItem('email');
      
      setContactForm(prev => ({
        ...prev,
        name: userName || '',
        email: userEmail || ''
      }));
    }

    // You could fetch contact info from API here
    // fetchContactInfo();
  }, []);

  const handleInputChange = (field, value) => {
    setContactForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!contactForm.name || !contactForm.email || !contactForm.message) {
      toast.error('Please fill all required fields');
      return;
    }

    if (!isValidEmail(contactForm.email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    setSubmitting(true);

    try {
      const userid = localStorage.getItem('userid');
      const userMobile = localStorage.getItem('mobile') || '';
      
      const formData = new FormData();
      formData.append('name', contactForm.name);
      formData.append('email', contactForm.email);
      formData.append('mobile', userMobile);
      formData.append('subject', contactForm.subject);
      formData.append('message', contactForm.message);

      const response = await fetch(`https://octafxx.in/Rest/contact_api/${userid || '0'}`, {
        method: 'POST',
        body: formData
      });

      const responseData = await response.json();
      
      if (responseData.status === 0) {
        toast.success(responseData.msg || 'Message sent successfully!');
        
        // Reset form
        setContactForm({
          name: localStorage.getItem('name') || '',
          email: localStorage.getItem('email') || '',
          subject: '',
          message: ''
        });
      } else {
        toast.error(responseData.msg || 'Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Contact submission error:', error);
      toast.error('Network error. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const ContactInfoItem = ({ icon, title, value, linkType = null }) => (
    <div className="d-flex align-items-start mb-3">
      <div className="flex-shrink-0">
        <div className="rounded-circle bg-primary bg-opacity-10 p-2 me-3">
          <i className={`bi bi-${icon} text-primary`}></i>
        </div>
      </div>
      <div className="flex-grow-1">
        <h6 className="fw-bold mb-1">{title}</h6>
        {linkType === 'phone' ? (
          <a href={`tel:${value}`} className="text-decoration-none">
            {value}
          </a>
        ) : linkType === 'email' ? (
          <a href={`mailto:${value}`} className="text-decoration-none">
            {value}
          </a>
        ) : (
          <p className="mb-0">{value}</p>
        )}
      </div>
    </div>
  );

  return (
    <div className="container-fluid bg-light min-vh-100">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* Header */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow">
        <div className="container-fluid">
          <div className="d-flex align-items-center">
            <button 
              className="btn btn-link text-white me-2"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left fs-4"></i>
            </button>
            <h1 className="navbar-brand mb-0 h1 fs-4">Contact Us</h1>
          </div>
          <div>
            <button 
              className="btn btn-outline-light btn-sm"
              onClick={() => navigate('/')}
            >
              <i className="bi bi-house me-1"></i>
              Home
            </button>
          </div>
        </div>
      </nav>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            {/* Hero Section */}
            <div className="text-center mb-5">
              <div className="mb-4">
                <div className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center p-4">
                  <i className="bi bi-headset fs-1 text-primary"></i>
                </div>
              </div>
              <h1 className="fw-bold text-primary mb-3">Get in Touch</h1>
              <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>
                Have questions? We're here to help. Send us a message and we'll respond as soon as possible.
              </p>
            </div>

            <div className="row">
              {/* Contact Form */}
              <div className="col-lg-12 mb-4 mb-lg-0">
                <div className="card shadow-sm border-0 h-100">
                  <div className="card-header bg-white border-0">
                    <h5 className="card-title mb-0 fw-bold">
                      <i className="bi bi-envelope text-primary me-2"></i>
                      Send us a Message
                    </h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-floating">
                            <input
                              type="text"
                              className="form-control"
                              id="name"
                              placeholder="Your Name"
                              value={contactForm.name}
                              onChange={(e) => handleInputChange('name', e.target.value)}
                              required
                            />
                            <label htmlFor="name">Your Name *</label>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="form-floating">
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              placeholder="Email Address"
                              value={contactForm.email}
                              onChange={(e) => handleInputChange('email', e.target.value)}
                              required
                            />
                            <label htmlFor="email">Email Address *</label>
                          </div>
                        </div>
                        
                        <div className="col-12">
                          <div className="form-floating">
                            <input
                              type="text"
                              className="form-control"
                              id="subject"
                              placeholder="Subject"
                              value={contactForm.subject}
                              onChange={(e) => handleInputChange('subject', e.target.value)}
                            />
                            <label htmlFor="subject">Subject</label>
                          </div>
                        </div>
                        
                        <div className="col-12">
                          <div className="form-floating">
                            <textarea
                              className="form-control"
                              id="message"
                              placeholder="Your Message"
                              value={contactForm.message}
                              onChange={(e) => handleInputChange('message', e.target.value)}
                              rows="5"
                              style={{ height: '150px' }}
                              required
                            ></textarea>
                            <label htmlFor="message">Your Message *</label>
                          </div>
                        </div>
                        
                        <div className="col-12">
                          <div className="d-grid">
                            <button 
                              type="submit" 
                              className="btn btn-primary btn-lg"
                              disabled={submitting}
                            >
                              {submitting ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                  Sending...
                                </>
                              ) : (
                                <>
                                  <i className="bi bi-send me-2"></i>
                                  Send Message
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

           
            </div>

          

           
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-dark text-white py-4 mt-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h6 className="fw-bold mb-3">Need Help?</h6>
              <p className="small opacity-75 mb-0">
                Our support team is here to assist you with any questions or concerns.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="mb-3">
                <small className="opacity-75">
                  © {new Date().getFullYear()} Contact Support. All rights reserved.
                </small>
              </div>
              <div>
                <a href="/privacy" className="text-white opacity-75 me-3 text-decoration-none">Privacy Policy</a>
                <a href="/terms" className="text-white opacity-75 me-3 text-decoration-none">Terms of Service</a>
                <a href="/faq" className="text-white opacity-75 text-decoration-none">FAQ</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;